<template>
    <div id="ai-auth-form-background">
        <div class="ai-auth-form-card">
            <div class="ai-auth-form-card__header">
                <img class="ai-auth-form-card__logo" src="@/assets/logo.svg" alt="logo" />
            </div>

            <div class="ai-auth-form-card__content">
                <slot />
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'form-card',
};
</script>

<style lang="scss" scoped>
#ai-auth-form-background {
    background-image: url('../../../assets/login-background.jpeg');
    background-size: 3400px 2000px;
    background-position-x: -1100px;
    background-position-y: -300px;
    height: 100%;
    display: flex;
    flex-direction: column;
    flex-shrink: 0;
}
.ai-auth-form-card {
    display: flex;
    flex-direction: column;
    flex-shrink: 0;

    margin: auto;

    width: 450px;
    height: 451px;
    min-height: 451px;
    padding: 22px 1px;
    gap: 1.5rem;

    background-color: rgba(255, 255, 255, 0.36);
    border-radius: 10px;
    box-shadow: 5px 5px 10px 5px #00000033;
    backdrop-filter: blur(10px);

    &__header {
        display: flex;
        flex-direction: column;
        align-items: center;
        margin-top: 20px;
        gap: 1.5rem;
    }

    &__title {
        font-family: 'Golos-Bold', GolosText, sans-serif;
        font-size: 24px;
        color: #000;
        text-align: center;
        margin-top: 10px;
        margin-left: 25px;
        margin-right: 25px;
    }

    &__content {
        display: flex;
        flex-direction: column;

        align-items: center;
        justify-content: center;

        margin-left: 0;
        margin-right: 0;
        margin-top: 15px;
    }

    &__logo {
        width: 232px;
        height: 70px;
    }
}
</style>
